import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=7c553c02&scoped=true&"
import script from "./Sticker.vue?vue&type=script&lang=js&"
export * from "./Sticker.vue?vue&type=script&lang=js&"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=7c553c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c553c02",
  null
  
)

component.options.__file = "Sticker.vue"
export default component.exports